<div class="container p-5 product-detail-description">
    <div class="row d-flex align-items-lg-center">
        <div class="col-12 col-lg-4 order-lg-5" *ngIf="imageId">
          <app-catalog-graphic imageClasses="border d-block mx-auto img-fluid product-detail-image"
            [imageId]="imageId"
            [imageSize]="256">
          </app-catalog-graphic>
        </div>
        <div class="col-12 col-lg-8 order-lg-1 mt-5 mt-lg-0">
            <span>{{vendorName}}</span>
            <h1 class="pb-2">{{name}}</h1>
            <p><strong>Version:&nbsp;</strong> <span>{{version}}</span>
            </p>
            <p>{{shortDescription}}</p>
        </div>
    </div>
</div>

<app-license-info *ngIf="hasOfferings" [offerings]="offerings"></app-license-info>
<app-license-expiration-warning *ngIf="hasOfferings" [offerings]="offerings"></app-license-expiration-warning>

<div *ngIf="hasOfferings; else noOfferings" class="my-5">
    <div *ngFor="let downloadItem of downloadsItems">
        <app-download-without-purchase-item
                [downloads]="downloadItem.downloads"
                [offering]="downloadItem.offering">
        </app-download-without-purchase-item>
    </div>
</div>

<ng-template #noOfferings>
    <div class="container my-5 px-3 px-lg-0">
        <div class="row mb-5 py-5">
            <div class="col-12 my-5">
                <p class=" h3 license-missing text-center">There are no downloads available for version {{version}} of
                    this product.</p>
            </div>
        </div>
    </div>
</ng-template>

